import {AfterViewInit, Component, Input} from '@angular/core';
import Tco from '../../models/tco';
import {Chart} from 'chart.js';

@Component({
  selector: 'app-tco-results',
  templateUrl: './tco-results.component.html',
  styleUrls: ['./tco-results.component.scss']
})
export class TcoResultsComponent implements AfterViewInit {

  @Input() tco?: Tco;
  @Input() chartId?: string;
  @Input() tcoTitle?: string;

  private chart: Chart | null = null;

  constructor() {
  }

  // ngOnInit(): void {
  //   console.log('hello world');
  //   // this.chart = this.generateTCOChart();
  //   // this.chart?.render();
  //   console.log('chart created');
  // }

  ngAfterViewInit(): void {
    this.generateTCOChart();
  }

  private generateTCOChart(): void {

    if (typeof this.tco === 'undefined' || typeof this.chartId === 'undefined') {
      return;
    }

    this.chart = new Chart(this.chartId, {
      type: 'doughnut',
      data: {
        labels: ['Precio', 'Combustible', 'Mantenimiento', 'Batería extra', 'Seguro', 'Patente', 'Infraestructura'],
        datasets: [
          {
            label: 'Test',
            data: [this.tco.vehiclePrice, this.tco.fuel, this.tco.maintenance, this.tco.batteryResidualValue,
              this.tco.insurance, this.tco.patent, this.tco.infrastructure],
            backgroundColor: [
              'rgb(255, 0, 0)',
              'rgb(0, 255, 0)',
              'rgb(0, 0, 255)',
              'rgb(255, 0, 255)',
              'rgb(255, 255, 0)',
              'rgb(0, 255, 255)',
              '#eee'
            ]
          }
        ]
      },
      options: {
        responsive: true
      }
    });

  }

  // Preserve original property order
  originalOrder = (a: any, b: any): number => {
    return 0;
  }

}
